<mat-form-field appearance="outline" class="w-full">
    <mat-label>{{ label }}</mat-label>
    <input matInput [readonly]="readonly" [formControl]="formControl" [disabled]="disableInput" [matDatepicker]="picker">
    <mat-datepicker-toggle *ngIf="withPicker" class="datepicker-toggle" matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker [disabled]="!disableInput"></mat-datepicker>
</mat-form-field>